import { Modal, Button, Typography } from 'antd';
import '@src/styles/components/customModal.scss';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Text as CustomText, useText } from '@src/components';

const { Text } = Typography;

const CustomDCCDeleteModal = ({
  title,
  isModalVisible,
  setIsModalVisible,
  deleted = '',
  vehicleCount = 0,
  isDepartment = true,
  nameArea = '',
}) => {

  const registeredText = useText('registered')
  const youHaveVehiclesText = useText('youHaveVehicles')
  const toCompletelyDeletePleaseText = useText('toCompletelyDeletePlease')
  const definedVehiclesToADifferentText = useText('definedVehiclesToADifferent')
  const pleaseAssignText = useText('pleaseAssign')
  const toTheDepartmentText = useText('toTheDepartment')
  const toTheCostCenterText = useText('toTheCostCenter')

  const areaText = isDepartment
    ? toTheDepartmentText
    : toTheCostCenterText;

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      title={<Text className="cost-center-modal-title">{title}</Text>}
      visible={isModalVisible}
      onCancel={handleCancel}
      style={{
        borderRadius: '8px',
        padding: '12px 14px 40px 39px',
      }}
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            paddingLeft: 10,
          }}
        >
          <Button
            key="ok"
            type="primary"
            style={{
              color: '#efefef',
              borderRadius: 6,
              width: 120,
              height: 38,
              fontWeight: 'bold',
            }}
            onClick={handleOk}
          >
            <CustomText t="okBtn" />
          </Button>
        </div>
      }
      centered
    >
      {deleted ? (
        <div className="cost-center-modal-deleted">
          <Text className="cost-center-modal-deleted-text">{deleted}</Text>
        </div>
      ) : (
        <Text className="cost-center-modal-text">
          <strong className="cost-center-modal-text-bold">
            {nameArea}
          </strong>{' '}
          {areaText} {registeredText}{' '}
          <strong className="cost-center-modal-text-bold">
            {vehicleCount}
          </strong>{' '}
          {youHaveVehiclesText}
          {areaText} {toCompletelyDeletePleaseText}{' '}
          {areaText} {definedVehiclesToADifferentText}{' '}
          {areaText} {pleaseAssignText}.
        </Text>
      )}
    </Modal>
  );
};

CustomDCCDeleteModal.propTypes = {
  title: PropTypes.string,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func,
  deleted: PropTypes.string,
  vehicleCount: PropTypes.number,
  isDepartment: PropTypes.bool,
  nameArea: PropTypes.string,
};

export default CustomDCCDeleteModal;
